import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  packingSlipSharing: {
    description: 'Packing slip sharing toggle description',
    defaultMessage: 'Share Packing Slip Templates',
    id: 'vGQ2rl',
  },
  packingSlipSharingTooltip: {
    description: 'Packing slip sharing tooltip message content',
    defaultMessage:
      'Your provider will be able to print packing slips using your templates when fulfilling orders you delegate to them. We recommend communicating with your provider after enabling this setting.',
    id: 'ixwQfy',
  },
});
